import { Component, HostListener, OnInit } from '@angular/core';
// import { Spinkit } from 'ng-http-loader/spinkits';
import { Router } from '@angular/router';
import { AuthService } from './shared/services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = 'app';

  // public spinkit = Spinkit;

  constructor(private router: Router, private authService: AuthService) {
  }

  ngOnInit() {
    if (!this.authService.getToken() || this.authService.isTokenExpired(this.authService.getToken()))
      this.router.navigate(['/login']);
  }

  // @HostListener('window:unload', ['$event'])
  // unloadHandler(event) {
  //     window.localStorage.clear();
  // }
}
